module.exports = __webpack_public_path__ + "static/media/dg1.4faefc66.PNG";